// Status mapping for each column
export const COLUMN_STATUS_MAP = {
  new: 'confirmed',
  preparing: 'preparing',
  ready: 'ready'
}

// Reverse mapping: status to column
export const STATUS_TO_COLUMN_MAP = {
  paid: 'new',
  confirmed: 'new',
  preparing: 'preparing',
  ready: 'ready'
}

export const INACTIVITY_TIMEOUT = 5 * 60 * 1000 // 5 minutes
